import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { OverlayTrigger, Popover } from 'react-bootstrap-5';
import { faLock } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  children: React.ReactElement,
  disabled?: string
}

export default function ExportUnavailable({ children, disabled }: Props) {
  if (!disabled) return children;

  return (
    <OverlayTrigger
      key="locked-popover"
      overlay={
        <Popover id="popover-contained">
          <Popover.Body>
            <div className="d-flex align-items-center mb-2">
              <FontAwesomeIcon icon={faLock} />
              <h6 className="m-0 ps-2">Upgrade Your Account</h6>
            </div>
            {disabled}
          </Popover.Body>
        </Popover>
      }
      placement="bottom"
    >
      {children}
    </OverlayTrigger >
  );
}
